var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loading-page"},[_c('p',{staticStyle:{"color":"#333","font-size":"1rem"}},[_vm._v(_vm._s(_vm.text))]),_c('square-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"height":_vm.height,"width":_vm.width}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }